import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { TextAreaPage } from '../../../../shared/pages/TextAreaPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryTextAreaRef } from '../../../../shared/types/toolTypes'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getCleanValue } from '../../../../shared/utils/getCleanValue'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { validateCharCount } from '../../../../shared/utils/validateCharCount'
import { UsedCardFlow, WhatProblemFlow } from '../../pageFlowData'
import { whatProblemData } from './data'

export const WhatProblem: FunctionComponent = () => {
  const { imgObj, title, placeholderText, descriptiveText, note } = whatProblemData
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    work: { problem },
  } = state

  const [WhatProblemTextAreaValid, setWhatProblemTextAreaValid] = useState<boolean>(true)

  const WhatProblemTextAreaRef = useRef<FormEntryTextAreaRef>(null)

  const handleChange = () => {
    const value = getCleanValue(WhatProblemTextAreaRef.current?.formEntryTextarea?.value)

    const isValid: boolean = validateCharCount(value.length, 2500)
    const fieldNotEmpty: boolean = isNotEmpty(value)
    if (fieldNotEmpty && isValid) {
      setWhatProblemTextAreaValid(true)
    }
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_PROBLEM', data: value })
    dispatch({ type: 'UPDATE_STEP', data: UsedCardFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: UsedCardFlow.PROGRESS_VALUE })
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${WhatProblemFlow.VIEW_NAME} | PII`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleSubmit = () => {
    const value: string = getCleanValue(WhatProblemTextAreaRef.current?.formEntryTextarea?.value)
    const isValid: boolean = validateCharCount(value.length, 2500)
    const isEmpty = !isNotEmpty(value)

    if (!isValid || isEmpty) {
      setWhatProblemTextAreaValid(false)
      return
    }

    setWhatProblemTextAreaValid(true)

    handleTracking()
    handleDispatch(value)
  }

  return (
    <div data-testid="What-Problem">
      <TextAreaPage
        buttonText="Next"
        defaultValue={problem}
        descriptiveText={descriptiveText}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        isFocused
        isInputValid={WhatProblemTextAreaValid}
        maxChars={2500}
        noteTop={note}
        optional={false}
        placeholderText={placeholderText}
        ref={WhatProblemTextAreaRef}
        title={title}
      />
    </div>
  )
}
